import { render, staticRenderFns } from "./PageExerciseGrouped.vue?vue&type=template&id=2ba9df9e"
import script from "./PageExerciseGrouped.vue?vue&type=script&lang=js"
export * from "./PageExerciseGrouped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports